import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=f5305ce0&scoped=true&"
import script from "./TaskDetails.vue?vue&type=script&lang=ts&"
export * from "./TaskDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&id=f5305ce0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5305ce0",
  null
  
)

export default component.exports